import styled from 'styled-components'

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 500px;
  padding: 0 5px;

  form {
    width: 100%;
  }

  @media screen and (max-width: 766px) {
    max-width: 420px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: 100%;

  transition: opacity 0.3s ease-in-out;

  h3 {
    width: 360px;
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 16px;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};

    strong {
      color: ${props => props.theme.colors.mainColor};
    }
  }

  > div {
    width: 100%
  }

  div#authorization {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 10px 0;

    > span {
      font-size: 14px;
      font-weight: 400;
      color: ${props => props.theme.colors.greyDarker};
      margin-left: 10px;
    }
  }
`

export const InfoBox = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;

  overflow: none;
  margin-bottom: 10px;
  padding: 5px 12px 8px;

  background: #FFF;
  border-radius: 4px;
  border: 2px solid #f4f6f5;
  box-shadow: 0px 2px 4px rgba(61, 69, 67, 0.05);
  transition: 0.2s;

  &:hover {
    border: 2px solid ${props => props.theme.colors.mainColor};
  }

  > div.placeholder {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: left;
    font-size: 14px;

    small {
      letter-spacing: 0.1em;
      font-weight: 550;
      margin: 4px 0;
      color: ${props => props.theme.colors.grey02}
    }

    svg {
      margin-left: 5px;
      color: ${props => props.theme.colors.warning};
      cursor: pointer;
      position: relative;
    }
  }

  .inputReg {
    padding: 0;
    border: none;
  }
`


